module.exports = __webpack_public_path__ + "img/menu-withdraw-yellow.394e9851.svg";